import { SearchItemPartials } from '@/lib/api/shopware/search/search.types'
import Text from '../../text'
import Image from 'next/image'
import { Button } from '@/components/ui/button'
import SearchResultDetails from './search-result-details'
import Link from 'next/link'
import { Dictionary } from '@/localization/dictionary'
import { generateSeoUrl } from '@/lib/utils/seo-url'
import React from 'react'

interface SearchResultProps {
  data?: SearchItemPartials[]
  setIsOpen: (state: boolean) => void
  searchInput: string
  dict?: Dictionary['productsSection']['seeAll']
}

const SearchResult = ({
  data,
  setIsOpen,
  searchInput,
  dict,
}: SearchResultProps) => {
  return (
    <>
      {!!data?.length && (
        <div className="mt-1 w-full animate-fade-in bg-white">
          <div className="border-b-[0.4px] border-black bg-gray-100 px-4 py-2">
            <Text as="p" variant={'secondary'} className="text-secondary-300">
              Product suggestions
            </Text>
          </div>

          {data.map((item) => {
            // Generate SEO-friendly URL using the utility function
            const slug = item.seoUrls?.[0]?.seoPathInfo || generateSeoUrl(item)

            return (
              <Link
                href={`/products/${slug}`}
                key={item.id}
                onClick={() => setIsOpen(false)}
              >
                <div className="flex cursor-pointer gap-3.75 border-b-[0.4px] border-black px-4 py-2">
                  <div className="size-15">
                    {item.image && item.name && (
                      <Image
                        priority
                        src={item.image}
                        height={200}
                        width={200}
                        alt={item.name}
                        className={`size-full object-cover`}
                      />
                    )}
                  </div>

                  <SearchResultDetails data={item} searchInput={searchInput} />
                </div>
              </Link>
            )
          })}

          <div className="flex items-center justify-center">
            <Button asChild variant={'ghost'} className="w-full uppercase">
              <Link
                href={`/search-view/${searchInput}`}
                onClick={() => setIsOpen(false)}
              >
                {dict ? dict : 'See All'}
              </Link>
            </Button>
          </div>
        </div>
      )}
    </>
  )
}

export default SearchResult
